import { render, staticRenderFns } from "./AppsMenu.vue?vue&type=template&id=199a8df4&scoped=true"
import script from "./AppsMenu.vue?vue&type=script&lang=js"
export * from "./AppsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199a8df4",
  null
  
)

export default component.exports